export default {
  "nav": {
    "home": "Accueil",
    "menu": "Menu",
    "mobile_app": "Application Mobile",
    "contact_us": "Nous Contacter",
    "sign_in": "Se Connecter",
    "cart": "Panier",
    "logout": "Déconnexion",
    "profile": "Profil",
    "orders": "Commandes",
    "notifications": "Notifications",
    "no_address_found": "Aucune adresse trouvée"
  },
  "header": {
    "title": "Cuisine Délicieuse, Livrée Rapidement",
    "description": "Connectez-vous avec les meilleurs restaurants locaux et profitez de vos cuisines préférées livrées directement à votre porte. DASHBASKET vous apporte des saveurs authentiques et un service exceptionnel, rendant chaque repas spécial sans quitter votre maison.",
    "greeting": "Salut, {{name}}",
    "there": "vous"
  },
  "buttons": {
    "add_to_cart": "Ajouter au Panier",
    "remove_from_cart": "Retirer du Panier",
    "place_order": "Passer Commande",
    "proceed_to_checkout": "Procéder au Paiement",
    "continue_shopping": "Continuer les Achats",
    "view_cart": "Voir le Panier",
    "update": "Mettre à Jour",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "confirm": "Confirmer",
    "back": "Retour",
    "next": "Suivant",
    "submit": "Soumettre",
    "search": "Rechercher",
    "filter": "Filtrer",
    "apply": "Appliquer",
    "reset": "Réinitialiser",
    "edit": "Modifier",
    "delete": "Supprimer",
    "view": "Voir"
  },
  "food": {
    "popular_dishes": "Plats Populaires",
    "new_arrivals": "Nouveautés",
    "recommended": "Recommandé",
    "vegetarian": "Végétarien",
    "vegan": "Végan",
    "gluten_free": "Sans Gluten",
    "spicy": "Épicé",
    "price": "Prix",
    "ingredients": "Ingrédients",
    "nutrition_info": "Informations Nutritionnelles",
    "calories": "Calories",
    "add_special_instructions": "Ajouter des instructions spéciales",
    "out_of_stock": "Épuisé",
    "food_item": "Article alimentaire",
    "unnamed_item": "Article sans nom",
    "no_description": "Aucune description disponible"
  },
  "footer": {
    "about_us": "À Propos",
    "privacy_policy": "Politique de Confidentialité",
    "terms_of_service": "Conditions d'Utilisation",
    "help_center": "Centre d'Aide",
    "contact": "Contact",
    "follow_us": "Suivez-nous",
    "download_app": "Téléchargez notre application",
    "all_rights_reserved": "Tous droits réservés",
    "google_play_store": "Google Play Store",
    "apple_app_store": "Apple App Store",
    "links": "Liens",
    "services": "Services",
    "apply_as_restaurant": "Postuler comme Restaurant",
    "apply_as_driver": "Postuler comme Chauffeur",
    "information": "Information",
    "support": "Support",
    "powered_by": "Propulsé par"
  },
  "restaurants": {
    "closed": "Fermé",
    "search_placeholder": "Rechercher des restaurants...",
    "filters": {
      "delivery_fee": "Frais de Livraison",
      "all_delivery_fees": "Tous les Frais de Livraison",
      "free_delivery": "Livraison Gratuite",
      "under_2000_bif": "Moins de 2000 BIF",
      "under_3000_bif": "Moins de 3000 BIF",
      "all_cuisines": "Toutes Cuisines",
      "all_prices": "Tous les Prix",
      "all_ratings": "Toutes Notes",
      "stars": "étoiles",
      "under_40_min": "Moins de 40 min",
      "open_now": "Ouvert",
      "closing_soon": "Ferme Bientôt",
      "no_restaurants_found": "Aucun restaurant trouvé correspondant à vos critères.",
      "clear_all_filters": "Effacer tous les filtres",
      "calculating_delivery_fee": "Calcul des frais de livraison...",
      "delivery_fee_unavailable": "Frais de livraison indisponibles",
      "no_reviews_yet": "Aucun avis",
      "new": "Nouveau",
      "km_away": "Km de vous"
    }
  },
  "cart": {
    "title": "Mon Panier",
    "confirm_clear_all": "Êtes-vous sûr de vouloir vider tous les paniers ?",
    "share_cart_details": "Partager les détails du panier",
    "cart_cleared": "Panier vidé avec succès",
    "failed_to_clear_cart": "Échec du vidage du panier",
    "failed_to_share_cart": "Échec du partage du panier",
    "cart_shared": "Panier partagé avec succès",
    "no_items": "Aucun article dans le panier",
    "subtotal": "Sous-total",
    "delivery_fee": "Frais de livraison",
    "total": "Total",
    "clear_cart": "Vider le Panier",
    "share_cart": "Partager le Panier",
    "proceed_to_order": "Procéder à la Commande",
    "loading": "Chargement du panier...",
    "error_loading": "Erreur de chargement du panier",
    "items": "articles",
    "checkout": "Commander",
    "add_more_items": "Ajouter plus d'articles",
    "item": "article",
    "continue_shopping": "Continuer les Achats",
    "share_fallback_error": "Échec du partage du panier. Veuillez essayer de copier le lien manuellement.",
    "share_failed_error": "Échec du partage du panier. Veuillez réessayer.",
    "share_url_copied": "Lien du panier copié dans le presse-papiers !",
    "empty_title": "Votre panier est vide",
    "empty_description": "Commencez à ajouter de délicieux plats à votre panier pour passer une commande.",
    "start_shopping": "Commencer les Achats",
    "share_modal_description": "Partagez ce panier avec vos amis et votre famille pour qu'ils puissent voir ce que vous commandez.",
    "copy_link": "Copier le Lien",
    "close": "Fermer",
    "remove_cart_title": "Supprimer le Panier",
    "remove_cart_message": "Êtes-vous sûr de vouloir supprimer le panier de {{restaurantName}} ? Cette action ne peut pas être annulée.",
    "remove_cart_confirm": "Supprimer le Panier",
    "remove_cart_cancel": "Garder le Panier",
    "removing_cart": "Suppression..."
  },
  "myOrders": {
    "title": "Mes Commandes",
    "loading": "Chargement de vos commandes...",
    "refresh": "Actualiser",
    "no_orders": "Aucune commande trouvée",
    "order_number": "Commande #",
    "status": "Statut",
    "date": "Date",
    "total": "Total",
    "view_details": "Voir les Détails",
    "track_order": "Suivre la Commande",
    "show_filters": "Afficher les Filtres",
    "hide_filters": "Masquer les Filtres",
    "all_statuses": "Tous les Statuts",
    "from_date": "Date de Début",
    "to_date": "Date de Fin",
    "apply": "Appliquer",
    "reset": "Réinitialiser",
    "unable_to_load": "Impossible de charger les commandes. Veuillez réessayer.",
    "retry": "Réessayer",
    "no_orders_found": "Aucune Commande Trouvée",
    "no_orders_match_filters": "Aucune commande ne correspond à vos filtres actuels.",
    "clear_filters": "Effacer les Filtres",
    "no_orders_yet": "Vous n'avez pas encore passé de commande.",
    "ready_to_order": "Prêt à commander de délicieux plats ? Parcourez nos restaurants et passez votre première commande !",
    "browse_restaurants": "Parcourir les Restaurants",
    "track": "Suivre",
    "cancel": "Annuler",
    "items": "Articles",
    "subtotal": "Sous-total",
    "pickup_fee": "Frais de Retrait",
    "delivery_fee": "Frais de Livraison",
    "delivery_address": "Adresse de Livraison",
    "name": "Nom",
    "address": "Adresse",
    "phone": "Téléphone",
    "not_provided": "Non fourni",
    "pickup_information": "Informations de Retrait",
    "pickup_location": "Lieu de Retrait",
    "restaurant": "Restaurant",
    "pickup_instructions": "Veuillez apporter une pièce d'identité valide et la confirmation de commande",
    "restaurant_name": "Nom du Restaurant",
    "restaurant_address": "Adresse du Restaurant",
    "address_not_available": "Adresse non disponible",
    "not_available": "Non disponible",
    "payment": "Paiement",
    "payment_status": "Statut du Paiement",
    "payment_method": "Méthode de Paiement",
    "online_payment": "Paiement en Ligne",
    "cash_on_delivery": "Paiement à la Livraison",
    "pending": "En Attente",
    "track_order": "Suivre la Commande",
    "cancel_order": "Annuler la Commande",
    "delivery_confirmation": "Confirmation de Livraison",
    "photo_taken_by_driver": "Photo prise par le chauffeur à l'adresse de livraison",
    "cancel_order_title": "Annuler la Commande",
    "cancel_order_confirm": "Êtes-vous sûr de vouloir annuler cette commande ?",
    "cancellation_reason": "Raison de l'annulation (optionnel) :",
    "cancellation_placeholder": "Veuillez fournir une raison pour annuler cette commande...",
    "confirm_cancellation": "Confirmer l'Annulation",
    "keep_order": "Garder la Commande",
    "processing": "Traitement..."
  },
  "placeOrder": {
    "invalid_order_details": "Détails de commande invalides. Veuillez recommencer.",
    "complete_order_first": "Veuillez d'abord compléter les détails de la commande",
    "cart_empty": "Votre panier est vide",
    "afripay_not_available": "Le paiement Afripay n'est pas disponible",
    "failed_create_payment": "Échec de la création de la session de paiement",
    "afripay_payment_failed": "Le paiement Afripay a échoué",
    "error_processing_order": "Erreur lors du traitement de votre commande",
    "server_not_responding": "Le serveur ne répond pas",
    "error_creating_order": "Erreur lors de la création de la commande",
    "order_placed_success": "Commande passée avec succès !",
    "failed_place_order": "Échec du passage de la commande",
    "validation_failed": "Échec de la validation",
    "sign_in_first": "Pour passer une commande, connectez-vous d'abord",
    "loading_order_details": "Chargement des détails de la commande...",
    "review_your_order": "Vérifiez Votre Commande",
    "review_order": "Vérifiez Votre Commande",
    "order_details": "Détails de la Commande",
    "delivery_order": "Commande de Livraison",
    "pickup_order": "Commande à Emporter",
    "items": "Articles",
    "customer_information": "Informations Client",
    "name": "Nom",
    "email": "Email",
    "phone": "Téléphone",
    "delivery_information": "Informations de Livraison",
    "instructions": "Instructions",
    "edit_order_details": "Modifier les Détails de la Commande",
    "payment_method": "Méthode de Paiement",
    "cash_on_delivery": "Paiement à la Livraison / Retrait",
    "mobile_money_bank_card": "Afripay",
    "order_summary": "Résumé de la Commande",
    "subtotal": "Sous-total",
    "delivery_fee": "Frais de livraison",
    "pickup_fee": "Frais de retrait",
    "total": "Total",
    "processing": "Traitement...",
    "place_order": "PASSER LA COMMANDE",
    "order_placed_successfully": "Commande passée avec succès !",
    "lumicash_payment": "Lumicash (Lumitel)",
    "coming_soon": "Bientôt disponible"
  },
  "payment": {
    "sign_in_to_complete": "Veuillez vous connecter pour compléter le paiement",
    "no_order_information": "Aucune information de commande trouvée",
    "order_placed_success": "Commande passée avec succès !",
    "failed_place_order": "Échec du passage de la commande",
    "failed_create_afripay": "Échec de la création du paiement Afripay",
    "processing_order": "Traitement de votre commande...",
    "loading": "Chargement...",
    "complete_payment": "Complétez Votre Paiement",
    "order_summary": "Résumé de la Commande",
    "subtotal": "Sous-total",
    "delivery_fee": "Frais de livraison",
    "total": "Total",
    "pay_with_afripay": "Payer avec Afripay",
    "redirect_afripay": "Vous serez redirigé vers Afripay pour compléter votre paiement en utilisant :",
    "lumicash": "Lumicash",
    "ecocash": "Ecocash",
    "amount_to_pay": "Montant à payer",
    "pay_with_afripay_alt": "Payer avec AfriPay",
    "secure_payment": "Votre paiement est traité en toute sécurité par Afripay",
    "payment_not_supported": "Méthode de Paiement Non Supportée",
    "select_valid_payment": "Veuillez revenir en arrière et sélectionner une méthode de paiement valide.",
    "go_back_to_cart": "Retourner au Panier"
  },
  "restaurant": {
    "restaurant_not_found": "Restaurant introuvable",
    "failed_to_load": "Échec du chargement du restaurant",
    "hours_not_available": "Heures non disponibles",
    "closed_today": "Fermé aujourd'hui",
    "open": "Ouvert",
    "closed": "Fermé",
    "closing_soon": "Fermeture Prochaine",
    "link_copied": "Lien du restaurant copié dans le presse-papiers !",
    "login_to_rate": "Veuillez vous connecter pour évaluer ce restaurant",
    "loading_restaurant": "Chargement du restaurant...",
    "error": "Erreur",
    "hide_info": "Masquer les infos du restaurant",
    "show_info": "Afficher les infos du restaurant",
    "hide_details": "Masquer les Détails",
    "show_details": "Afficher les Détails",
    "hide": "Masquer",
    "show": "Afficher",
    "share_restaurant": "Partager le restaurant",
    "share": "Partager",
    "rate_restaurant": "Évaluer le restaurant",
    "rate": "Évaluer",
    "search_menu": "Rechercher dans le menu de {{name}}...",
    "cuisine": "Cuisine",
    "price": "Prix",
    "rating": "Évaluation",
    "hours": "Heures",
    "phone": "Téléphone",
    "address": "Adresse"
  },
  "orderDetails": {
    "cart_empty": "Votre panier est vide",
    "failed_calculate_delivery": "Échec du calcul des frais de livraison",
    "outside_delivery_area": "L'emplacement sélectionné est en dehors de notre zone de livraison. Nous ne livrons actuellement que dans Bujumbura Mairie.",
    "delivery_info_saved": "Informations de livraison enregistrées",
    "customer_info_saved": "Informations client enregistrées",
    "failed_save_delivery": "Échec de l'enregistrement des informations de livraison",
    "failed_save_customer": "Échec de l'enregistrement des informations client",
    "first_name_required": "Le prénom est requis",
    "last_name_required": "Le nom de famille est requis",
    "email_required": "L'email est requis",
    "phone_required": "Le numéro de téléphone est requis",
    "street_required": "L'adresse de rue est requise",
    "quartier_required": "Le quartier est requis",
    "city_required": "La ville est requise",
    "state_required": "L'état est requis",
    "country_required": "Le pays est requis",
    "click_map_select": "Veuillez cliquer sur la carte pour sélectionner votre emplacement de livraison exact",
    "save_delivery_info": "Veuillez enregistrer vos informations de livraison pour continuer",
    "fill_required_fields": "Veuillez remplir tous les champs requis",
    "order_details": "Détails de la Commande",
    "order_type": "Type de Commande",
    "delivery": "Livraison",
    "pickup": "Retrait",
    "customer_information": "Informations Client",
    "first_name": "Prénom",
    "last_name": "Nom de Famille",
    "email_address": "Adresse Email",
    "phone_number": "Numéro de Téléphone",
    "delivery_information": "Informations de Livraison",
    "street_address": "Adresse de Rue",
    "quartier": "Quartier",
    "city": "Ville",
    "state": "État",
    "country": "Pays",
    "zip_code_optional": "Code Postal (Optionnel)",
    "select_delivery_location": "Sélectionner l'Emplacement de Livraison",
    "hide_map": "Masquer la Carte",
    "show_map": "Afficher la Carte",
    "location_confirmed": "Emplacement confirmé",
    "delivery_instructions_optional": "Instructions de Livraison (Optionnel)",
    "saving": "Enregistrement...",
    "delivery_info_saved": "Infos de Livraison Enregistrées",
    "save_delivery_info": "Enregistrer les Informations de Livraison",
    "estimated_delivery_fee": "Frais de livraison estimés",
    "order_summary": "Résumé de la Commande",
    "subtotal": "Sous-total",
    "delivery_fee": "Frais de livraison",
    "pickup_fee": "Frais de retrait",
    "calculating": "Calcul...",
    "total": "Total",
    "continue_to_payment": "Continuer vers le Paiement"
  },
  "resetPassword": {
    "invalid_or_expired_link": "Lien de réinitialisation invalide ou expiré",
    "failed_send_reset_email": "Échec de l'envoi de l'email de réinitialisation. Veuillez réessayer.",
    "passwords_not_match": "Les mots de passe ne correspondent pas",
    "password_too_short": "Le mot de passe doit contenir au moins 6 caractères",
    "password_reset_success": "Mot de passe réinitialisé avec succès ! Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
    "failed_reset_password": "Échec de la réinitialisation du mot de passe. Veuillez réessayer.",
    "invalid_reset_link": "Lien de Réinitialisation Invalide",
    "link_invalid_expired": "Le lien de réinitialisation du mot de passe est invalide ou a expiré.",
    "back_to_home": "Retour à l'Accueil",
    "reset_password": "Réinitialiser le Mot de Passe",
    "set_new_password": "Définir un Nouveau Mot de Passe",
    "enter_email_send_link": "Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    "enter_new_password": "Entrez votre nouveau mot de passe ci-dessous.",
    "email_address": "Adresse Email",
    "enter_email": "Entrez votre email",
    "sending": "Envoi...",
    "send_reset_link": "Envoyer le Lien de Réinitialisation",
    "back_to_login": "Retour à la Connexion",
    "new_password": "Nouveau Mot de Passe",
    "enter_new_password": "Entrez le nouveau mot de passe",
    "confirm_new_password": "Confirmer le Nouveau Mot de Passe",
    "confirm_new_password_placeholder": "Confirmer le nouveau mot de passe",
    "resetting": "Réinitialisation..."
  },
  "restaurantApply": {
    "file_too_large": "Le fichier est trop volumineux. La taille maximale est de 5MB. Taille du fichier : {{size}} MB",
    "select_location_map": "Veuillez sélectionner l'emplacement de votre restaurant sur la carte. Ceci est requis pour les services de livraison.",
    "location_outside_service": "L'emplacement sélectionné est en dehors de notre zone de service.",
    "please_provide": "Veuillez fournir :",
    "business_license": "Licence Commerciale",
    "business_license_expiry": "Expiration de la Licence Commerciale",
    "menu_food_license": "Licence Menu/Alimentation",
    "menu_food_license_expiry": "Expiration de la Licence Menu/Alimentation",
    "insurance_certificate": "Certificat d'Assurance",
    "insurance_certificate_expiry": "Expiration du Certificat d'Assurance",
    "application_submitted": "Candidature soumise avec succès ! Nous examinerons vos informations et vous contacterons bientôt.",
    "problem_submitting": "Il y a eu un problème lors de la soumission de votre candidature. Veuillez réessayer plus tard.",
    "become_partner": "Devenir Partenaire Restaurant",
    "join_network": "Rejoignez notre réseau de restaurants et atteignez plus de clients avec DASHBASKET !",
    "restaurant_information": "Informations du Restaurant",
    "restaurant_name": "Nom du Restaurant*",
    "cuisine_type": "Type de Cuisine*",
    "cuisine_example": "ex : Italien, Chinois, Mexicain",
    "restaurant_description": "Description du Restaurant*",
    "tell_about_restaurant": "Parlez-nous de votre restaurant",
    "website_optional": "Site Web (si disponible)",
    "website_example": "https://www.votrerestaurant.com",
    "own_delivery": "Nous avons notre propre service de livraison",
    "contact_information": "Informations de Contact",
    "owner_manager_name": "Nom du Propriétaire/Gestionnaire*",
    "email_address": "Adresse Email*",
    "phone_number": "Numéro de Téléphone*",
    "phone_example": "ex : +257 79 123456 ou 79123456",
    "restaurant_location": "Emplacement du Restaurant",
    "address_street": "Adresse/Rue*",
    "quartier": "Quartier*",
    "city": "Ville*",
    "country": "Pays*",
    "zip_code": "Code Postal",
    "restaurant_location_map": "Emplacement du Restaurant sur la Carte*",
    "required": "Requis :",
    "pin_exact_location": "Épinglez l'emplacement exact de votre restaurant sur la carte. Ceci est essentiel pour que les chauffeurs de livraison trouvent votre restaurant et pour nos services de livraison.",
    "hide_map": "Masquer la Carte",
    "select_location_map": "Sélectionner l'Emplacement sur la Carte *",
    "location_selected": "Emplacement sélectionné sur la carte",
    "location_selection_required": "Sélection d'emplacement requise",
    "required_documents": "Documents Requis",
    "upload_required_documents": "Télécharger les Documents Requis*",
    "all_3_documents": "Les 3 documents sont requis :",
    "max_file_size": "Taille maximale : 5MB par fichier. Formats acceptés : PDF, DOC, DOCX, JPG, PNG",
    "business_license_required": "1. Licence Commerciale*",
    "expiration_date": "Date d'Expiration*",
    "menu_food_license_required": "2. Licence Menu/Alimentation*",
    "insurance_certificate_required": "3. Certificat d'Assurance*",
    "all_documents_uploaded": "Tous les documents requis téléchargés",
    "upload_all_documents": "Veuillez télécharger tous les documents requis",
    "additional_information": "Informations Supplémentaires",
    "other_details": "Tout autre détail que vous aimeriez partager",
    "submitting": "Soumission...",
    "submit_application": "Soumettre la Candidature"
  },
  "sharedCart": {
    "invalid_share_link": "Lien de partage invalide",
    "cart_not_found": "Panier partagé introuvable ou supprimé",
    "failed_load_cart": "Échec du chargement du panier partagé",
    "failed_load_into_carts": "Échec du chargement du panier partagé dans vos paniers",
    "loading_shared_cart": "Chargement du panier partagé...",
    "unable_load_cart": "Impossible de Charger le Panier Partagé",
    "go_to_my_carts": "Aller à Mes Paniers",
    "go_home": "Aller à l'Accueil",
    "cart_not_found_title": "Panier Partagé Introuvable",
    "cart_removed_invalid": "Ce panier a peut-être été supprimé ou le lien est invalide.",
    "shared_cart": "Panier Partagé",
    "shared_by": "Partagé par",
    "items": "articles",
    "items_in_cart": "Articles dans ce panier :",
    "cart_empty": "Ce panier est vide",
    "qty": "Qté :",
    "each": "chacun",
    "total": "Total :",
    "visit_restaurant": "Visiter le Restaurant",
    "loading": "Chargement...",
    "add_to_my_carts": "Ajouter à Mes Paniers",
    "subtotal": "Sous-total :",
    "delivery_fee": "Frais de livraison :"
  },
  "verify": {
    "verifying_payment": "Vérification de votre paiement...",
    "order_id_missing": "L'ID de commande est manquant dans l'URL. Veuillez vérifier le lien et réessayer.",
    "authentication_required": "Authentification requise. Veuillez vous connecter et réessayer.",
    "payment_cancelled": "Le paiement a été annulé. Vous pouvez essayer de passer la commande à nouveau.",
    "payment_verified": "Paiement vérifié avec succès ! Redirection vers vos commandes...",
    "payment_verification_failed": "Échec de la vérification du paiement. Veuillez contacter le support.",
    "authentication_failed": "Échec de l'authentification. Veuillez vous reconnecter.",
    "order_not_found": "Commande introuvable. Veuillez vérifier les détails de la commande.",
    "verification_failed_contact": "Échec de la vérification du paiement. Veuillez contacter le support si cela persiste.",
    "go_back_to_cart": "Retourner au Panier",
    "try_again": "Réessayer",
    "view_my_orders": "Voir Mes Commandes",
    "processing_payment": "Traitement du Paiement",
    "processing_payment_please_wait": "Traitement de votre paiement. Veuillez patienter pendant que nous confirmons votre paiement avec le fournisseur. Cela peut prendre jusqu'à 2 minutes.",
    "complete_payment_on_phone": "Veuillez consulter votre téléphone et terminer le paiement mobile money pour confirmer votre commande. En attente de confirmation du paiement...",
    "complete_payment_title": "Terminez le Paiement sur Votre Téléphone",
    "payment_timeout": "Délai de vérification du paiement expiré. Veuillez vérifier vos commandes ou contacter le support si le paiement a été débité.",
    "payment_successful": "Paiement Réussi !",
    "payment_failed": "Paiement Échoué",
    "payment_cancelled": "Paiement Annulé",
    "payment_cancelled_title": "Paiement Annulé",
    "thank_you_order": "Merci pour votre commande ! Vous recevrez un email de confirmation sous peu.",
    "track_order_status": "Vous pouvez suivre le statut de votre commande dans la section 'Mes Commandes'.",
    "track_order_my_orders": "Vous pouvez suivre le statut de votre commande dans la section 'Mes Commandes'.",
    "contact_support_if_issues": "Si vous continuez à rencontrer des problèmes, veuillez contacter notre équipe de support."
  },
  "driverApply": {
    "file_too_large": "Le fichier est trop volumineux. La taille maximale est de 5MB. Taille du fichier : {{size}} MB",
    "please_provide": "Veuillez fournir :",
    "drivers_license": "Permis de Conduire",
    "drivers_license_expiry": "Expiration du Permis de Conduire",
    "vehicle_insurance": "Assurance Véhicule",
    "vehicle_insurance_expiry": "Expiration de l'Assurance Véhicule",
    "vehicle_registration": "Immatriculation du Véhicule",
    "vehicle_registration_expiry": "Expiration de l'Immatriculation du Véhicule",
    "application_submitted": "Candidature soumise avec succès ! Nous examinerons vos informations et vous contacterons bientôt.",
    "problem_submitting": "Il y a eu un problème lors de la soumission de votre candidature. Veuillez réessayer plus tard.",
    "become_driver": "Devenir Chauffeur de Livraison",
    "join_team": "Rejoignez notre équipe de partenaires de livraison et gagnez de l'argent selon votre propre horaire !",
    "personal_information": "Informations Personnelles",
    "first_name": "Prénom*",
    "last_name": "Nom de Famille*",
    "email_address": "Adresse Email*",
    "phone_number": "Numéro de Téléphone*",
    "phone_example": "ex : +257 79 123456 ou 79123456",
    "address_information": "Informations d'Adresse",
    "street_address": "Adresse de Rue*",
    "quartier_zone": "Quartier/Zone*",
    "city": "Ville*",
    "country": "Pays*",
    "postal_code": "Code Postal",
    "driver_information": "Informations du Chauffeur",
    "drivers_license_number": "Numéro de Permis de Conduire*",
    "vehicle_type": "Type de Véhicule*",
    "car": "Voiture",
    "motorcycle": "Moto",
    "bicycle": "Vélo",
    "scooter": "Scooter",
    "other": "Autre",
    "vehicle_make": "Marque du Véhicule*",
    "vehicle_make_example": "ex : Toyota, Honda",
    "vehicle_model": "Modèle du Véhicule*",
    "vehicle_model_example": "ex : Camry, Civic",
    "vehicle_year": "Année du Véhicule*",
    "vehicle_year_example": "ex : 2019",
    "availability_experience": "Disponibilité et Expérience",
    "availability": "Disponibilité*",
    "full_time": "Temps plein",
    "part_time": "Temps partiel",
    "weekends_only": "Weekends seulement",
    "evenings_only": "Soirées seulement",
    "flexible_hours": "Heures flexibles",
    "preferred_delivery_areas": "Zones de Livraison Préférées",
    "delivery_areas_example": "ex : Centre-ville, Côté Ouest, Zone Sud",
    "delivery_experience": "Expérience de Livraison*",
    "no_experience": "Aucune expérience préalable",
    "less_than_1_year": "Moins d'1 an",
    "1_2_years": "1-2 ans",
    "3_5_years": "3-5 ans",
    "5_plus_years": "5+ ans",
    "additional_information": "Informations Supplémentaires",
    "upload_required_documents": "Télécharger les Documents Requis*",
    "all_3_documents": "Les 3 documents sont requis :",
    "max_file_size": "Taille maximale : 5MB par fichier. Formats acceptés : PDF, DOC, DOCX, JPG, PNG",
    "drivers_license_required": "1. Permis de Conduire*",
    "expiration_date": "Date d'Expiration*",
    "vehicle_insurance_required": "2. Certificat d'Assurance Véhicule*",
    "vehicle_registration_required": "3. Document d'Immatriculation du Véhicule*",
    "all_documents_uploaded": "Tous les documents requis téléchargés",
    "upload_all_documents": "Veuillez télécharger tous les documents requis",
    "agree_background_check": "J'accepte une vérification d'antécédents*",
    "other_details": "Tout autre détail que vous aimeriez partager",
    "submitting": "Soumission...",
    "submit_application": "Soumettre la Candidature"
  },
  "orderTracking": {
    "order_tracking": "Suivi de Commande",
    "order_number": "Commande #",
    "current_status": "Statut Actuel",
    "estimated_delivery": "Livraison Estimée",
    "driver_information": "Informations du Chauffeur",
    "your_delivery_driver": "Votre Chauffeur de Livraison",
    "driver_assigned": "Chauffeur assigné",
    "driver_not_assigned": "Les informations du chauffeur apparaîtront une fois assigné",
    "call_driver": "Appeler le Chauffeur",
    "vehicle": "Véhicule",
    "live_tracking": "Suivi en Temps Réel",
    "updating_route": "Mise à jour de l'itinéraire...",
    "estimated_arrival": "Arrivée Estimée",
    "calculating": "Calcul...",
    "distance": "Distance",
    "via_fastest_route": "via l'itinéraire le plus rapide",
    "traffic": "Trafic",
    "light_traffic": "Trafic léger",
    "moderate_traffic": "Trafic modéré",
    "heavy_traffic": "Trafic dense",
    "checking_traffic": "Vérification du trafic...",
    "loading_enhanced_map": "Chargement de la carte améliorée...",
    "live_tracking_with_route": "Suivi en temps réel avec visualisation de l'itinéraire",
    "your_driver": "Votre Chauffeur",
    "delivery_location": "Lieu de Livraison",
    "optimal_route": "Itinéraire Optimal",
    "last_location_update": "Dernière mise à jour de localisation",
    "updates_every_30_seconds": "Mises à jour toutes les 30 secondes",
    "route_summary": "Résumé de l'Itinéraire",
    "duration": "Durée",
    "min_delay": "min de retard",
    "pickup_information": "Informations de Retrait",
    "pickup_location": "Lieu de Retrait",
    "pickup_instructions": "Instructions de Retrait",
    "bring_valid_id": "Apporter une pièce d'identité valide",
    "show_order_confirmation": "Montrer la confirmation de commande",
    "pay_at_pickup": "Payer au retrait (si paiement à la livraison)",
    "order_ready": "Votre commande est prête !",
    "come_to_restaurant": "Veuillez venir au restaurant pour récupérer votre commande.",
    "order_picked_up": "Commande récupérée avec succès !",
    "thank_you_service": "Merci d'utiliser notre service.",
    "status_updates": "Mises à Jour de Statut",
    "delivery_confirmation": "Confirmation de Livraison",
    "refresh_tracking": "Actualiser le Suivi",
    "real_time_updates_active": "Mises à jour en temps réel actives",
    "real_time_updates_disconnected": "Mises à jour en temps réel déconnectées",
    "last_updated": "Dernière mise à jour",
    "arriving_now": "Arrive maintenant",
    "minute": "minute",
    "minutes": "minutes",
    "hour": "heure",
    "hours": "heures",
    "expected_shortly": "Attendu sous peu",
    "calculating_eta": "Calcul...",
    "meters": "m",
    "kilometers": "km"
  }
}; 